export default "__VITE_ASSET__64ac91fa__"